import * as React from "react";
import {useEffect, useState} from "react";
import {useAppDispatch} from "app.hook";
import {
    addGiftCartPromotion,
    removeGiftCartPromotion,
    setCartPromotion,
    setShoppingCart,
    updateGiftCartPromotionQuantity,
} from "states/shopping-cart/shopping-cart.slice";
import {closeConfirmModal, setLoading, showConfirmModal, showError,} from "states/global-value/global-value.slice";

import {ModalComponent} from "shared/components/modal/modal";
import {formatMoney, redirectFileLocalUrl,} from "shared/plugins/string-helper";
import {IconClose, IconMinus, IconPlus} from "themes";
import {ConfirmModel} from "states/global-value/global-value.models";
import ShoppingCart, {
    ShoppingCartGiftItemModel,
    ShoppingCartPromotionModel,
} from "states/shopping-cart/shopping-cart.models";
import _ from "lodash";
import {CartPromotionModel,} from "states/cart-promotion/cart-promotion.models";
import {PromotionProductRequestModel, PromotionValueType,} from "states/promotion/promotion.models";
import {applyMultiplePromotionCartAPI} from "states/cart-promotion/cart-promotion.api";
import {checkFreeCondition, PromotionProductModel} from "states/promotion-model-shared";

export interface IApplyCartPromotionComponentProps {
    shoppingCart: ShoppingCart;
}

export function ApplyCartPromotionComponent(
    props: IApplyCartPromotionComponentProps
) {
    const {shoppingCart} = props;
    const [modalSelectProduct, setModalSetProduct] = useState<boolean>(false);
    const [category, setCategory] = useState<string>("");
    const [cartPromotions, setCartPromotions] = useState<CartPromotionModel[]>(
        []
    );
    const [cartPromotionIndex, setCartPromotionIndex] = useState<number>(0);
    const dispatch = useAppDispatch();
    const handleInitCoupon = async () => {
        dispatch(setLoading(true));
        try {
            let result = await applyMultiplePromotionCartAPI({
                subTotalAmount: shoppingCart.subTotal,
                branchId: shoppingCart.branch.id,
                products: shoppingCart.items.map((m) => {
                    return {
                        id: m.productId,
                        quantity: m.quantity,
                    } as PromotionProductRequestModel;
                })
            });
            let promotionDiscounts = result.data.filter(x => x.type === PromotionValueType.Discount);
            dispatch(setLoading(false));
            dispatch(
                setCartPromotion({
                    discount: Number(promotionDiscounts.map(x => x.discountValue).reduce((a, b) => a + b, 0) ?? 0),
                    cartPromotions: result.data.map(x => {
                        return {
                            cartPromotionName: x.code,
                            cartPromotionItems: [],
                        } as ShoppingCartPromotionModel
                    }),
                })
            );
            setCartPromotions(result.data);
        } catch (err) {
            setShoppingCart({
                ...shoppingCart,
                cartPromotions: [],
            });
            setCartPromotions([]);
            dispatch(setLoading(false));
        }
    };
    useEffect(() => {
        if (shoppingCart.items?.length > 0) {
            handleInitCoupon();
        }
    }, [shoppingCart.items]);
    useEffect(()=>{
        setCartPromotionIndex(0);
        setCategory("");
    },[modalSelectProduct])
    const handleUpdateGiftQuantity = (cartPromotionIndex: number, index: number, quantity: number) => {
        dispatch(updateGiftCartPromotionQuantity({cartPromotionIndex, index, quantity}));
    };
    const handleRenderCategoryDropdown = () => {
        let temp = [...cartPromotions.filter(x=> x.type === PromotionValueType.Gift)][cartPromotionIndex];
        let groupByCategoryName = _.groupBy(temp.gifts, (m) => m.categoryName);
        let optionHtml = [];
        optionHtml.push(<option value="">-- Select Category --</option>);
        for (let key in groupByCategoryName) {
            optionHtml.push(<option value={key}>{key}</option>);
        }
        return (
            <select
                value={category}
                onChange={(ev) => {
                    setCategory(ev.target.value);
                }}
                className="form-control w-full py-2 mb-4"
            >
                {optionHtml}
            </select>
        );
    };
    const handleAddItem = (cartPromotion: CartPromotionModel, shoppingCartPromotions: ShoppingCartPromotionModel[],
                           shoppingCartPromotionIndex: number,
                           shoppingCartPromotionItems: ShoppingCartGiftItemModel[],
                           id: number, price: number) => {
        if (shoppingCartPromotionItems.map((x) => x.id).includes(id)) {
            shoppingCartPromotionItems = shoppingCartPromotionItems?.filter((p) => p.id !== id);
        } else {
            if (
                cartPromotion.numberOfGifts <=
                shoppingCartPromotionItems
                    .map((m) => m.quantity)
                    .reduce((a, b) => a + b, 0)
            ) {
                dispatch(
                    showError(
                        `You can select up to ${cartPromotion.numberOfGifts} free item(s)`
                    )
                );
                return;
            }
            if (!checkFreeCondition({...cartPromotion}, shoppingCartPromotionItems, price, 1)) {
                dispatch(
                    showError(`You can select up to 0 free item(s)`)
                );
                return;
            }
            shoppingCartPromotionItems.push({
                id: id,
                quantity: 1,
                maxPrice: price,
            } as ShoppingCartGiftItemModel);
        }
        dispatch(
            addGiftCartPromotion({ cartPromotionIndex: shoppingCartPromotionIndex, items:shoppingCartPromotionItems})
        );
    }
    const handleRenderGiftOfPromotion = (isSelected: boolean) => {
        let cartPromotionTemp = {...cartPromotions.filter(x=> x.type === PromotionValueType.Gift)[cartPromotionIndex]};
        let cartPromotionsTemp = [...cartPromotions];
        let cartPromotionGiftItems = cartPromotionsTemp.reduce((prev: PromotionProductModel[],current,index) => {
            return prev.concat(current.gifts);
        }, []);

        if (isSelected) {
            return shoppingCart.cartPromotions
                .map((m, shoppingCartPromotionCartIndex) => {
                    return m.cartPromotionItems.map((x,cartItemIndex) => {
                        let itemSelected = cartPromotionGiftItems.find(z => z.id == x.id);
                        return (
                            <React.Fragment>
                                {itemSelected && (
                                    <div
                                        className="item-gift flex content-center items-start mb-4  rounded-md shadow-lg">
                                        <div className="avatar-container">
                                            <div className="img-container rounded-md">
                                                {itemSelected.image !== null ? (
                                                    <img
                                                        className="object-center rounded-md"
                                                        src={redirectFileLocalUrl(itemSelected.image ?? "")}
                                                        alt=""
                                                    />
                                                ) : (
                                                    <div
                                                        className="flex content-center rounded-md items-center avatar-thumb h-full w-full bg-yellow-50"></div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="info w-full">
                                            <div className="name ">
                                                <span className="text-sm font-semibold uppercase">
                                                  {itemSelected.name} x {x.quantity ?? "1"}
                                                </span>
                                            </div>
                                            <div className="flex justify-between content-center items-center">
                                                <div className="text-red text-sm font-semibold uppercase">
                                                    {formatMoney(0, 2, ".", ",", "$")}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="icon">
                                            <IconClose
                                                width={20}
                                                className="cursor-pointer"
                                                onClick={() => {
                                                    dispatch(
                                                        showConfirmModal({
                                                            title: "Confirm",
                                                            message: `Are you sure you want to delete this?`,
                                                            onYes: () => {
                                                                dispatch(
                                                                    removeGiftCartPromotion({cartPromotionIndex: shoppingCartPromotionCartIndex, index:cartItemIndex })
                                                                );
                                                                dispatch(closeConfirmModal());
                                                            },
                                                        } as ConfirmModel)
                                                    );
                                                }}
                                            />
                                        </div>
                                    </div>
                                )}
                            </React.Fragment>
                        )
                    });
                });
        }
        return cartPromotionTemp.gifts
            .filter((m) => {
                return category === "" || m.categoryName === category;
            })
            .map((m, index) => {
                let itemSelected = shoppingCart.cartPromotions.find(x => x.cartPromotionName === cartPromotionTemp.code)?.cartPromotionItems.find(
                    (x) => x.id === m.id
                );
                let shoppingCartPromotions = [...shoppingCart.cartPromotions];
                let shoppingCartPromotionIndex = shoppingCartPromotions.findIndex(x => x.cartPromotionName === cartPromotionTemp.code);
                let shoppingCartPromotionItems = [...shoppingCartPromotions[shoppingCartPromotionIndex]?.cartPromotionItems ?? []];
                return (
                    <React.Fragment>
                        <div
                            className={`item-gift flex content-center items-start mb-4  rounded-md shadow-lg ${
                                itemSelected !== undefined ? `active` : ``
                            }`}
                        >
                            <div
                                className="avatar-container"
                                onClick={() => {
                                    handleAddItem(cartPromotionTemp, shoppingCartPromotions, shoppingCartPromotionIndex, shoppingCartPromotionItems, m.id, m.price);
                                }}
                            >
                                <div className="img-container rounded-md">
                                    {m.image !== null ? (
                                        <img
                                            className="object-center rounded-md"
                                            src={redirectFileLocalUrl(m.image ?? "")}
                                            alt=""
                                        />
                                    ) : (
                                        <div
                                            className="flex content-center rounded-md items-center avatar-thumb h-full w-full bg-yellow-50"></div>
                                    )}
                                </div>
                            </div>
                            <div className="info w-full">
                                <div
                                    className="name"
                                    onClick={() => {
                                        handleAddItem(cartPromotionTemp, shoppingCartPromotions, shoppingCartPromotionIndex, shoppingCartPromotionItems, m.id, m.price);
                                    }}
                                >
                              <span className="text-sm font-semibold uppercase">
                                {m.name}
                              </span>
                                </div>
                                {itemSelected && (
                                    <div
                                        className="quantity-container flex place-content-center justify-between content-center items-center">
                                        <button
                                            onClick={() => {
                                                if (itemSelected === undefined) {
                                                    return;
                                                }
                                                let itemIndex =
                                                    shoppingCartPromotionItems.findIndex(
                                                        (m) => m.id === itemSelected?.id
                                                    );
                                                if (itemSelected.quantity - 1 === 0) {
                                                    return;
                                                }
                                                handleUpdateGiftQuantity(
                                                    shoppingCartPromotionIndex,
                                                    itemIndex,
                                                    itemSelected.quantity - 1
                                                );
                                            }}
                                            className="btn--default outline-none border-none p-2"
                                        >
                                            <IconMinus width={20}/>
                                        </button>
                                        <span className="text-md">{itemSelected.quantity}</span>
                                        <button
                                            onClick={() => {
                                                if (itemSelected === undefined) {
                                                    return;
                                                }
                                                let productIndex =
                                                    shoppingCartPromotionItems.findIndex(
                                                        (m) => m.id === itemSelected?.id
                                                    );
                                                if (
                                                    cartPromotionTemp.numberOfGifts <
                                                    shoppingCartPromotionItems
                                                        .filter((m) => m.id !== itemSelected?.id)
                                                        .map((m) => m.quantity)
                                                        .reduce((a, b) => a + b, 0) +
                                                    itemSelected.quantity +
                                                    1
                                                ) {
                                                    dispatch(
                                                        showError(
                                                            `You can select up to ${cartPromotionTemp.numberOfGifts} free item(s)`
                                                        )
                                                    );
                                                    return;
                                                }
                                                if (!checkFreeCondition({...cartPromotionTemp}, shoppingCartPromotionItems, m.price, 1)) {
                                                    dispatch(
                                                        showError(
                                                            `You can select up to ${itemSelected.quantity} free item(s)`
                                                        )
                                                    );
                                                    return;
                                                }
                                                handleUpdateGiftQuantity(
                                                    shoppingCartPromotionIndex,
                                                    productIndex,
                                                    itemSelected.quantity + 1
                                                );
                                            }}
                                            className="btn--default outline-none p-2"
                                        >
                                            <IconPlus width={20}/>
                                        </button>
                                    </div>
                                )}
                            </div>
                            {itemSelected && (
                                <div className="icon">
                                    <IconClose
                                        width={20}
                                        className="cursor-pointer"
                                        onClick={() => {
                                            let productIndex =
                                                shoppingCartPromotionItems.findIndex(
                                                    (m) => m.id === itemSelected?.id
                                                );
                                            dispatch(
                                                removeGiftCartPromotion({cartPromotionIndex: shoppingCartPromotionIndex,index: productIndex })
                                            );
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </React.Fragment>
                );
            });
    };

    return (
        <div className="promotion mt-2 mb-2">
            {cartPromotions?.filter(x => x.type === PromotionValueType.Gift).length > 0 && (
                <React.Fragment>
                    <button
                        className="btn--primary w-full px-8 py-4 my-8 uppercase"
                        onClick={() => {
                            setModalSetProduct(true);
                        }}
                    >
                        SELECT FREE ITEM(S)
                    </button>
                    <div className="gift-select-container">
                        {handleRenderGiftOfPromotion(true)}
                    </div>
                    <ModalComponent
                        width={`100%`}
                        height={`100%`}
                        isModal={false}
                        className="w-full bg-white rounded-2xl"
                        isCustomizeFooter={true}
                        onCloseModal={() => {
                            setModalSetProduct(false);
                        }}
                        isOpenModal={modalSelectProduct}
                        title={`SELECT FREE ITEM(S)`}
                    >
                        <div className="pt-3">
                            <div className="category-dropdown">
                                {handleRenderCategoryDropdown()}
                            </div>
                            <div className="gifts-container">
                                {handleRenderGiftOfPromotion(false)}
                            </div>
                            <div className="btn__container">
                                {cartPromotions.filter(x => x.type === PromotionValueType.Gift).length - 1 > cartPromotionIndex ? (
                                    <button
                                        onClick={() => {
                                            let cartPromotionIndexTemp = cartPromotionIndex;
                                            setCartPromotionIndex(cartPromotionIndexTemp+ 1);
                                        }}
                                        className="btn--primary w-full px-8 py-4 uppercase font-semibold"
                                    >
                                        Next
                                    </button>
                                ) : (
                                    <button
                                        onClick={() => {
                                            setModalSetProduct(false);
                                        }}
                                        className="btn--primary w-full px-8 py-4 uppercase font-semibold"
                                    >
                                        Save
                                    </button>
                                )}

                            </div>
                        </div>
                    </ModalComponent>
                </React.Fragment>
            )}
        </div>
    );
}
